import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
  Button,
  Divider,
} from "@mui/material";
import { toast } from "react-toastify";
import { useUserData } from "features/User/hooks/user-data.hook";
import {
  COLLECTION_OVERVIEW_OPTIONS,
  normalizeCollectionOverviewValue,
} from "features/Collections/data/collection-overview-options";

const CollectionOverviewPreference = () => {
  const { userPreferences, upsertUserPreference } = useUserData();
  const [selectedOverview, setSelectedOverview] = useState("mediaBias");
  const [saveLoading, setSaveLoading] = useState(false);

  useEffect(() => {
    if (userPreferences?.defaultCollectionOverview) {
      setSelectedOverview(
        normalizeCollectionOverviewValue(userPreferences.defaultCollectionOverview)
      );
    } else {
      setSelectedOverview("mediaBias");
    }
  }, [userPreferences]);

  const handleChange = (event) => {
    setSelectedOverview(event.target.value);
  };

  const handleSave = async () => {
    setSaveLoading(true);
    const { userAvatar, ...restPreferences } = userPreferences || {};
    try {
      await upsertUserPreference({
        ...restPreferences,
        defaultCollectionOverview: selectedOverview,
      });
      const selectedLabel =
        COLLECTION_OVERVIEW_OPTIONS.find((o) => o.value === selectedOverview)
          ?.label || selectedOverview;
      toast.success(
        `Default Collection Overview updated to ${selectedLabel} successfully!`
      );
    } catch (error) {
      toast.error("Failed to update default collection overview");
    } finally {
      setSaveLoading(false);
    }
  };

  return (
    <Box sx={{ width: { sm: "100%", md: "60%" }, mb: 2 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        Default Collection Overview
      </Typography>
      <Typography sx={{ mb: 2 }}>
        Choose which chart is shown by default when you open a Collection. You
        can always switch between charts directly on the Collections page. Select{" "}
        <strong>Media Bias</strong> to see the AllSides Media Bias Rating
        distribution, or <strong>Source Category</strong> to see a breakdown of
        source categories.
      </Typography>
      <FormControl fullWidth sx={{ maxWidth: 400 }}>
        <InputLabel id="collection-overview-label">
          Select Default View
        </InputLabel>
        <Select
          labelId="collection-overview-label"
          id="collection-overview-select"
          value={selectedOverview}
          label="Select Default View"
          onChange={handleChange}
        >
          {COLLECTION_OVERVIEW_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Divider sx={{ my: 2 }} />
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          onClick={handleSave}
          disabled={saveLoading}
          sx={{ display: "flex", gap: 1 }}
        >
          {saveLoading && <CircularProgress size={20} />}
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default CollectionOverviewPreference;
